import { cn } from '@/shadcn/lib/utils';
import { Input as ShadcnInput } from '@/shadcn/components/ui/input';
import React from 'react';

type InputVariant = 'rounded' | 'default';

interface Props extends React.ComponentProps<typeof ShadcnInput> {
    variant?: InputVariant;
    leftIcon?: React.ReactNode;
    numeric?: boolean;
    unstyled?: boolean;
    disableFocusStyles?: boolean;
}

export function Input({
    variant = 'default',
    className,
    leftIcon,
    numeric,
    unstyled,
    disableFocusStyles,
    ...props
}: Props) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (numeric) {
            const onlyNumbers = e.target.value.replace(/\D/g, '');
            e.target.value = onlyNumbers;
        }

        props.onChange?.(e);
    };

    return (
        <div className="relative w-full">
            {leftIcon && (
                <div className="absolute left-[12px] top-1/2 -translate-y-1/2 flex items-center pointer-events-none xl:left-[15px]">
                    {leftIcon}
                </div>
            )}

            <ShadcnInput
                {...props}
                className={cn(
                    'h-[40px] text-[13px] px-[15px] ',
                    'xl:h-[45px] xl:px-[20px]',
                    disableFocusStyles && [
                        '!shadow-none',
                        '!ring-0',
                        'focus:!ring-0',
                        'focus-visible:!ring-0',
                        'focus-visible:!shadow-none',
                        'focus-visible:!outline-none',
                        'focus-visible:!border-input',
                    ],
                    unstyled && [
                        'shadow-none',
                        'ring-0 focus-visible:ring-0 focus-visible:ring-offset-0',
                        'border border-border focus-visible:border-border',
                    ],
                    leftIcon && 'pl-[36px] xl:pl-[38px]',
                    variant === 'rounded' && 'rounded-[30px]',
                    className,
                )}
                inputMode={numeric ? 'numeric' : props.inputMode}
                onChange={handleChange}
            />
        </div>
    );
}
